import styled from "styled-components";

export const Container = styled.section`
  padding-top: 15%;
  display: flex;
  justify-content: space-between;
  gap: 8rem;
  background: rgba(0,0,0,0);
  .hero-text{
    & > p{
      font-size: 1.8rem;
    }
    h1{
      font-size: 7rem;
    }

    h3{
      color:var(--green);
      margin: 1rem 0;
    }

    
    p.small-resume {
      margin-bottom: 5rem;
    }
  }
// New added
  .social-media{
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding-top:5rem;
    padding-left:1rem;

    img,span{
      font-size: 3rem;
      width: 3.5rem;
    }
  }


  .button{
    margin-top: 5rem;
    padding: 1.4rem 6rem;
  }

  .hero-image{
    img{
      max-width: 500px;
    }
  }

  .terminal {
    background: var(--terminal-bg);
    border: 1px solid var(--terminal-border);
    border-radius: 6px;
    width: 100%;
    max-width: 600px;
    min-height: 320px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(0,0,0,0.5);
    font-family: 'Fira Code', monospace;

    .terminal-header {
      background: var(--terminal-header);
      padding: 1rem;
      display: flex;
      gap: 0.8rem;
      border-bottom: 1px solid var(--terminal-border);

      span {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        &:nth-child(1) { background: #ff5f56; }
        &:nth-child(2) { background: #ffbd2e; }
        &:nth-child(3) { background: #27c93f; }
      }
    }

    .terminal-body {
      padding: 2rem;
      font-size: 1.4rem;
      line-height: 2rem;
      min-height: 280px;

      .command {
        color: var(--green);
        margin-bottom: 1rem;
        display: block;
        &::before {
          content: "$ ";
          color: var(--blue);
        }
      }

      .response {
        color: #d1d5db;
        margin-bottom: 1.5rem;
        word-break: break-all;
        display: block;
      }

      @keyframes blink {
        0%, 100% { opacity: 1; }
        50% { opacity: 0; }
      }

      .cursor {
        display: inline-block;
        width: 8px;
        height: 18px;
        background: var(--green);
        margin-left: 4px;
        vertical-align: middle;
        animation: blink 1s step-end infinite;
      }
    }
  }

  @media(max-width: 960px){
    display: block;
    margin-top: 15%;
    .hero-text{

      h1{
        font-size: 5rem;
      }
    }
    
    .hero-image{
      margin-top: 5rem;
      display: flex;
      justify-content: center;
    }

    .terminal {
      min-height: 400px;
    }
  }

  @media(max-width: 600px){
    margin-top: 35%;
  }
  @media(max-width: 480px){
    margin-top: 45%;
  }
`